import { ProjectT, UserT } from "../../../models/models";
import { StatusE, UserRoleE } from "../../../models/enums";
import getAdIdsFromVersions from "./getAdIdsFromVersions";
import getAdIdFromFileName from "./getAdidFromFileName";
import {type FineUploader } from "fine-uploader";

function removeMXFFilesIfBroadcaster(
  user: UserT,
  project: ProjectT,
  addedFiles: any[],
  uploader: any
) {
    if (
        user?.role === UserRoleE.Broadcaster ||
        project.StatusName === StatusE.DownloadedByBroadcaster ||
        project.StatusName === StatusE.DownloadedByAllBroadcasters
      ) {
        const mxfAdIds = getAdIdsFromVersions(project.Versions, true);

        addedFiles.forEach((file) => {
          const uploadedFileAdId = getAdIdFromFileName(file);
          if (!mxfAdIds.includes(uploadedFileAdId)) {
            uploader.deleteFile((file as any).id);
          }
        });
      }
}

export default removeMXFFilesIfBroadcaster;
